"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterOption = void 0;
var _esToolkit = require("es-toolkit");
var _useTranslations = require("../../hooks/useTranslations");
var _ColorOption = require("./optionTypes/ColorOption");
var _DefaultOption = require("./optionTypes/DefaultOption");
var _isColorOption = require("./utils/isColorOption");
var _jsxRuntime = require("react/jsx-runtime");
const FilterOption = (props)=>{
    const { formatMessage } = (0, _useTranslations.useTranslations)();
    const { label: name, selected, onClick, onDelete, LabelProps, OptionProps, value, count } = props;
    const label = (0, _esToolkit.isNil)(count) ? name : formatMessage('facetNameAndCount', {
        name,
        count
    });
    if ((0, _isColorOption.isColorOption)(props)) {
        const { hexColors } = props;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ColorOption.ColorOption, {
            label: label,
            value: value,
            hexColors: hexColors,
            selected: selected,
            LabelProps: LabelProps,
            OptionProps: OptionProps,
            onClick: onClick,
            onDelete: onDelete
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DefaultOption.DefaultOption, {
        label: label,
        value: value,
        selected: selected,
        LabelProps: LabelProps,
        OptionProps: OptionProps,
        onClick: onClick,
        onDelete: onDelete
    });
};
exports.FilterOption = FilterOption;
